import React from 'react';
import { Container, Badge } from 'react-bootstrap';

const skills = [
  'Product Development',
  'Project Management',
  'Incident Management',
  'Vendor Management',
  'Risk Management',
  'Strategic Planning',
  'Budgeting and Forecasting',
  'FinTech',
  'Payments',
  'Crypto',
  'Web3',
  'DeFi',
  'AI',
  'Data Engineering',
  'Cybersecurity',
  'Cloud Infrastructure',
  'Site Reliability Engineering (SRE)',
  'DevOps',
];

const Skills: React.FC = () => {
  return (
    <section id="skills" className="py-5">
      <Container>
        <h2 className="text-center mb-4">Skills</h2>
        <div className="d-flex flex-wrap justify-content-center">
          {skills.map((skill, index) => (
            <Badge bg="primary" className="m-1 p-2 rounded-pill fs-5" key={index}>
              {skill}
            </Badge>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Skills;
